import React from 'react'
import * as PhosphorIcons from '@phosphor-icons/react'
const ModalRunAgainContent = ({ open, onClose, onRunAgain, content, filteredAgents}) => {
  return (
    <dialog className={`modal ${open ? 'modal-open' : ''}`}>
        <div className="modal-box">
          <h3 className="font-bold text-lg">Confirm Run Again</h3>
          <p className="py-4">Are you sure you want to run <span
            className="font-bold">{content?.title}</span> again? We will run the content again with the selected agents(s). You have selected <strong>{filteredAgents.length}</strong> agent(s).</p>
          <ul className="grid grid-cols-2 gap-2 max-h-[40vh] overflow-y-auto">
            {filteredAgents.map(agent => (
              <li key={agent?.id}>
                <a
                  className="hover:bg-base-300 active:bg-base-300 transition-colors p-2 block rounded-lg"
                >
                  <div className="flex items-center gap-2">
                    <div className={`p-1 rounded-lg ${agent?.bg_class}`}>
                      {PhosphorIcons[agent?.icon] ?
                        React.createElement(PhosphorIcons[agent?.icon], {
                          size: 16,
                          className: agent?.color_class,
                        })
                        :
                        <PhosphorIcons.Tag size={16}
                                         className={agent.color_class}/>
                      }
                    </div>
                    <span className="font-medium text-sm truncate">{agent.label}</span>
                  </div>
                </a>
              </li>
            ))}
          </ul>
          <div className="modal-action">
            <button className="btn btn-xs btn-outline" onClick={onClose}>
              <span className="mr-2">Cancel</span>
              <PhosphorIcons.X size={16}/>
            </button>
            <button className="btn btn-xs btn-info btn-outline"
                    onClick={() => {
                      onRunAgain()
                      onClose()
                    }}>
              <span className="mr-2">Run Again</span>
              <PhosphorIcons.Play size={16}/>
            </button>
          </div>
        </div>
        <form method="dialog" className="modal-backdrop bg-base-100/20" onClick={onClose}>
          <button>close</button>
        </form>
      </dialog>
  )
}

export default ModalRunAgainContent